// src/components/app-download/AppDownloadModal.tsx
import React from "react";
import { getDownloadLink } from "../../utils/app-download-link";
import AppLogo from "../../assets/images/mahi-download-logo-512.png";
import { track } from "@amplitude/analytics-browser";
import FadeInWrapper from "../common/fade-in-wrapper";

interface AppDownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  where?: string; // amplitude에서 쓰이는 값임! (다운로드 클릭 위치 추적용)
}

const AppDownloadModal: React.FC<AppDownloadModalProps> = ({
  isOpen,
  onClose,
  where, // amplitude에서 where는 다운로드 클릭 위치 등 추적용으로 사용됩니다.
}) => {
  if (!isOpen) return null; // 모달이 열리지 않으면 아무것도 렌더링하지 않음

  return (
    <div className="fixed inset-0 z-[130] mx-auto flex max-w-[742px] items-center justify-center bg-black bg-opacity-50">
      <FadeInWrapper className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md">
        {/* 로고와 제목 */}
        <img src={AppLogo} alt="App Logo" className="w-20 h-20 mb-2 mx-auto" />
        <h2 className="text-lg font-bold text-gray-800 text-center">
          이 기능은 앱에서만 사용할 수 있어요 🥲
        </h2>
        <p className="text-md text-gray-600 text-center">
          앱을 다운로드하고 알림을 받아보세요
        </p>

        {/* 버튼 영역 */}
        <div className="flex gap-4 mt-4 w-full">
          {/* 닫기 버튼 */}
          <button
            onClick={onClose}
            className="flex-1 py-3 bg-gray-300 text-gray-700 font-bold rounded-lg shadow-md hover:bg-gray-400 transition-all duration-200"
          >
            닫기
          </button>

          {/* 다운로드 버튼 */}
          <a
            href={getDownloadLink()}
            className="flex-1 py-3 bg-[#1692fc] text-white font-bold rounded-lg shadow-md flex items-center justify-center hover:bg-[#1177cc] transition-all duration-200"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              track("앱 다운로드 클릭", { 어디서: where });
            }}
          >
            다운로드
          </a>
        </div>
      </FadeInWrapper>
    </div>
  );
};

export default AppDownloadModal;
